<div
  class="d-flex justify-content-end mb-2"
  role="dialog"
  [attr.aria-label]="'YouTube video'"
  [attr.aria-modal]="true"
>
  <button
    type="button"
    class="close"
    [attr.aria-label]="'Close video modal'"
    (keydown.enter)="$event.preventDefault()"
    (click)="close()"
    role="button"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

@if (youtubeUrl) {
  <div role="region" [attr.aria-label]="'Video content'">
    <iframe
      width="500"
      height="315"
      src=""
      title="YouTube video player"
      [src]="youtubeUrl | calioSafe: 'resourceUrl'"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      [attr.aria-label]="'YouTube video player'"
    ></iframe>
  </div>
}